module.exports = __webpack_public_path__ + "img/img_banner_shentou.62ddae9e.png";